module.exports = __webpack_public_path__ + "media/images/people-d0d281e4.svg";